import { BillingIcon } from "outline-icons";
import * as React from "react";
import stores from "~/stores";
import { Hook, PluginManager } from "~/utils/PluginManager";
import config from "../plugin.json";

PluginManager.add([
  {
    ...config,
    type: Hook.Settings,
    value: {
      group: "Workspace",
      after: "Details",
      icon: BillingIcon,
      component: React.lazy(() => import("./Billing")),
      enabled: (team) => {
        const can = stores.policies.abilities(team.id);
        return (
          (team.trialEndsAt && can.createPlanSubscription) ||
          can.updatePlanSubscription
        );
      },
    },
  },
]);
